const mutations = {
    setBulkManualUploadList(state, payload) {
      state.bulkUploadPayoutList = payload;
    },
 };

    
    export default mutations;